/**
 * Keeps page content clear of the fixed header.
 *
 * The category row wraps, so the header's height depends on how many
 * categories exist and how wide the viewport is — it cannot be a constant.
 * This publishes the measured height as --vault-nav-h, which vault-custom.css
 * uses for the content offset.
 */
(function () {
  var nav = document.querySelector('.vault-nav');
  if (!nav) return;

  var last = -1;

  function apply() {
    var h = nav.offsetHeight;
    if (h && h !== last) {
      last = h;
      document.documentElement.style.setProperty('--vault-nav-h', h + 'px');
    }
  }

  apply();
  window.addEventListener('resize', apply);
  // Fonts landing after first paint can change the row count, so re-measure.
  window.addEventListener('load', apply);
  if (window.ResizeObserver) new ResizeObserver(apply).observe(nav);
})();
